import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function ReaddyAgentWidget() {
  const { i18n } = useTranslation();

  useEffect(() => {
    // Configurações de texto por idioma
    const languageConfig = {
      pt: {
        mainLabel: 'Fale Connosco',
        startButton: 'Iniciar',
        endButton: 'Terminar Chamada',
        emptyMessage: 'Pronto para ajudar'
      },
      en: {
        mainLabel: 'Talk with Us',
        startButton: 'Start',
        endButton: 'End Call',
        emptyMessage: 'Ready to assist'
      },
      es: {
        mainLabel: 'Habla con Nosotros',
        startButton: 'Iniciar',
        endButton: 'Terminar Llamada',
        emptyMessage: 'Listo para ayudar'
      }
    };

    const currentLang = i18n.language as keyof typeof languageConfig;
    const config = languageConfig[currentLang] || languageConfig.pt;

    // Atualizar atributos do script
    const updateWidgetLanguage = () => {
      const script = document.getElementById('readdy-agent-script');
      if (script) {
        script.setAttribute('main-label', config.mainLabel);
        script.setAttribute('start-button-text', config.startButton);
        script.setAttribute('end-button-text', config.endButton);
        script.setAttribute('empty-chat-message', config.emptyMessage);
        script.setAttribute('empty-voice-message', config.emptyMessage);
        
        // Forçar recarga do widget
        const widgetContainer = document.querySelector('[data-vapi-widget]');
        if (widgetContainer) {
          // Remover e recriar o widget
          const parent = widgetContainer.parentElement;
          if (parent) {
            widgetContainer.remove();
            
            // Aguardar um pouco e recarregar o script
            setTimeout(() => {
              const newScript = document.createElement('script');
              newScript.id = 'readdy-agent-script';
              newScript.src = 'https://readdy.ai/api/public/assistant/widget?projectId=9bd54680-2004-4603-b3d9-53938d866689';
              newScript.setAttribute('mode', 'hybrid');
              newScript.setAttribute('voice-show-transcript', 'true');
              newScript.setAttribute('theme', 'light');
              newScript.setAttribute('size', 'compact');
              newScript.setAttribute('accent-color', '#F97316');
              newScript.setAttribute('button-base-color', '#1E293B');
              newScript.setAttribute('button-accent-color', '#FFFFFF');
              newScript.setAttribute('main-label', config.mainLabel);
              newScript.setAttribute('start-button-text', config.startButton);
              newScript.setAttribute('end-button-text', config.endButton);
              newScript.setAttribute('empty-chat-message', config.emptyMessage);
              newScript.setAttribute('empty-voice-message', config.emptyMessage);
              newScript.defer = true;
              
              document.body.appendChild(newScript);
            }, 100);
          }
        }
      }
    };

    updateWidgetLanguage();
  }, [i18n.language]);

  return null;
}
